import { INIT_ERROR_PAYMENT, ERROR_PAYMENT } from "../types/error.types";

export function errorPayment(code, declineCode, message, options) {
  return {
    type: ERROR_PAYMENT,
    response: { code, declineCode, message, options },
  };
}

export function initErrorPayment() {
  return {
    type: INIT_ERROR_PAYMENT,
  };
}
